
const modelIdFromGeneratedClassName = (className) => {
    if (!className || typeof className !== 'string') {
        return null;
    }

    const shortName = className.split(/\\+/).pop();
    const words = shortName?.match(/[A-Z]+(?![a-z])|[A-Z][a-z0-9]*/g);
    if (!words || words.length < 2) {
        return null;
    }

    const moduleId = words.slice(0, -1).join('-').toLowerCase();
    const modelName = words[words.length - 1].toLowerCase();
    return `${moduleId}/${modelName}`;
};

export const resolveReferenceModelId = (data) => {
    if (data?.reference?.modelId) {
        return data.reference.modelId;
    }

    return (
        modelIdFromGeneratedClassName(data?.reference?.modelClassName) ||
        modelIdFromGeneratedClassName(data?.modelClassName)
    );
};